import * as z from "zod";

export const getNetSuiteOAuthUrl = {
  name: "getNetSuiteOAuthUrl" as const,
  input: z.object({}),
  output: z.object({ authUrl: z.string() }),
};
